/**
*@title 일정 안내
*@date 2022-02-09
*@author 홍수희
*@desc
*@etc(change)
*/

import React from 'react';
import { Link } from "react-router-dom";
import { t } from 'i18next';

import visitor_overview from '../../images/designed_table/visitor_overview.svg';
import visitor_overview_en from '../../images/designed_table/visitor_overview_en.svg';


const GuideOverview = () => {
    const scrollToTop = () => {
        window.scrollTo(0, 0)
    }
    return(
        <div className="sect-01-box-01-visitor">
            <div className="sect-tit">{t("vis_guide_overview_title")}</div>
            <div className="tbl-visitor-guide-overview">
                <div style={{textAlign:"center"}}>
                <div className='w-full md:w-10/12' style={{display:"inline-block", maxWidth:"1100px"}}>
                    {
                        t("lang") === "ko" 
                        ?<img src={visitor_overview}  style={{display:"inline-block"}}/>
                        :<img src={visitor_overview_en} style={{display:"inline-block"}}/>
                    }
                </div>
                </div>
                <div style={{marginTop:"5vw", textAlign:"center"}}>
                    <ul>
                        <li style={{display:"inline-block", marginRight:"2vw"}}>
                            <Link to="/about/seminar" onClick={scrollToTop}>
                                <div className='visitor-guide-quick-btn btn-color'>
                                    {t("vis_guide_overview_button1")}
                                </div>
                            </Link>
                        </li>
                        <li style={{display:"inline-block", marginRight:"2vw"}}>
                            <Link to="/about/event" onClick={scrollToTop}>
                                <div className='visitor-guide-quick-btn btn-color'>
                                    {t("vis_guide_overview_button2")}
                                </div>
                            </Link>
                        </li>
                        <li style={{display:"inline-block"}}>
                            <Link to="/exhibitor/company" onClick={scrollToTop}>
                                <div className='visitor-guide-quick-btn btn-color'>
                                    {t("vis_guide_overview_button3")}
                                </div>
                            </Link>
                        </li>
                    </ul>
                </div>
                {/* <table>
                    <colgroup>
                        <col width="20%"/>
                        <col width="80%"/>
                    </colgroup>
                    <tbody>
                    <tr>
                        <td class="firstcolumn">{t("vis_guide_overview_col1")}</td>
                        <td>{t("vis_guide_overview_cont1")}</td>
                    </tr>
                    <tr>
                        <td class="firstcolumn">{t("vis_guide_overview_col2")}</td>
                        <td>
                            {t("vis_guide_overview_cont2_1")}
                            <br/>
                            {t("vis_guide_overview_cont2_2")}
                        </td>
                    </tr>
                    <tr>
                        <td class="firstcolumn">{t("vis_guide_overview_col3")}</td>
                        <td>
                            <div className='visitor-guide-overview-cont-wrap'>
                                <div className='visitor-guide-overview-cont'>
                                    <img src={ueco_logo}/>
                                </div>
                                <div className='visitor-guide-overview-cont'>
                                    {t("vis_guide_overview_cont3")}
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="firstcolumn">{t("vis_guide_overview_col4")}</td>
                        <td>{t("vis_guide_overview_cont4")}</td>
                    </tr>
                    </tbody>
                </table> */}
            </div>
        </div>
    )
}

export default GuideOverview;